import React from 'react'

import LargeContentToggle from 'components/Common/LargeContentToggle'
import MarkdownRender from 'components/Luxkit/MarkdownRender'

interface Props {
  content: string
}

function Notes({ content }: Props) {
  return (
    <div>
      <LargeContentToggle
        maxHeight={210}
        collapsedHeight={132}
        showMoreText="Read more"
        showLessText="Read less"
        showChevron={false}
      >
        <MarkdownRender content={content} type="compact" fontSize="medium" />
      </LargeContentToggle>
    </div>
  )
}

export default Notes
